<template>
    <div
        class="l-ss-c-checkbox"
        :class="{
            'l-ss-c-checkbox-disabled': disabled,
            'l-ss-c-checkbox-checked': isChecked
        }">
        <label>
            <input
                type="checkbox"
                :disabled="disabled"
                :value="value"
                @change="$emit('change', { event: $event, value: !value })">
            <slot></slot>
        </label>
    </div>
</template>

<script>
    import { computed } from '@vue/composition-api';

    export default {
        props: {
            value: {
                type: Boolean,
                required: true,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        setup(props, { emit }) {
            const isChecked = computed({
                get() {
                    return props.value;
                },
                set(value) {
                    emit('change', value);
                },
            });

            return {
                isChecked,
            };
        },
    };
</script>
